'use strict';

angular.module('docketbook')
.controller('companySettingsUomsController', function(resourceService, $q, $scope, $window, Restangular, $state, $stateParams, accessControl) {
  mixpanel.track("Opened CompanySettings-Uoms Desktop");

  $scope.currentUser = accessControl.currentUser();
  $scope.currentState = $state.current;
  $scope.currentOrg = accessControl.currentOrg();
  $scope.currentOrgGroup = accessControl.currentOrgGroup();

  $scope.query = {
    limit: 10,
    page: 1,
    order: 'abbreviation'
  };
  $scope.selected = [];
  $scope.listCount = 0;

  $scope.timeTypes = [ 'hours', 'hoursminutes', 'minutes' ];

  $scope.loadUomsList = function() {
    $scope.promise = $q(function(resolve, reject) {
      var queryParams = {};
      queryParams.limit = $scope.query.limit;
      queryParams.offset = $scope.query.limit * ($scope.query.page - 1);
      resourceService.getUoms(queryParams, function(uoms) {
        $scope.allUoms = uoms;
        if ( queryParams.offset <= 0 && uoms.length < queryParams.limit ) {
          $scope.listCount = uoms.length;
        } else {
          $scope.listCount = queryParams.offset + (queryParams.limit + 1);
        }
        resolve('Done');
      }, function(err) {
        $scope.allUoms = [];
        reject('Error');
      });
    });
  }

  $scope.loadUomsList();

  $scope.goTo = function(href) {
    $window.location.href = href;
  }

  $scope.openMenu = function($mdOpenMenu, ev) {
    $mdOpenMenu(ev);
  };

  /********************************/
  /***** Unit of Measure Func *****/
  /********************************/

  // Create a new uom modal
  $scope.openNewUomModal = function() {
    $scope.uomEdit = {};
    $scope.uomEdit.isTime = false;
    $("#newUomModal").fadeIn(100);
  }

  $scope.editUom = function(uom) {
    $scope.uomEdit = uom;
    $("#newUomModal").fadeIn(100);
  }

  // Close new uom modal
  $scope.closeNewUomModal = function() {
    $("#newUomModal").fadeOut(100);
    $scope.uomEdit = {};
  }

  // Save a new uom for the organisation
  $scope.saveNewUom = function(uom) {
    uom.loading = true;
    if ( uom.isTime == null ) {
      uom.isTime = false;
    }
    resourceService.saveUom(uom, function(updatedUom) {
      $scope.closeNewUomModal();
      $scope.loadUomsList();
    }, function(err) {
      uom.loading = false;
      $scope.alertService.presentAutoAlert('saveUom', err);
    });
  }

  $scope.deleteUom = function(uom) {
    swal({
			title: "Are you sure?",
			text: "You will not be able to recover this unit of measure!",
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#DD6B55",
			confirmButtonText: "Yes, delete it!",
			cancelButtonText: "No, cancel!",
			closeOnConfirm: false,
			closeOnCancel: true
		}, function(isConfirm){
			if (isConfirm) {
        resourceService.removeUom(uom.id, function(success) {
          swal("Deleted!", "The unit of measure has been deleted.", "success");
          $scope.loadUomsList();
        }, function(err) {
          swal({
            title: "Error!",
            text: "An error occured while deleting the unit of measure.",
            type: "error",
            confirmButtonText: "Ok, got it."
          });
        });
			}
		});
  }

  $scope.deleteSelectedUoms = function() {
    var count = $scope.selected.length;
    swal({
			title: "Are you sure?",
			text: count + " uom's will be deleted.",
			type: "warning",
			showCancelButton: true,
			confirmButtonColor: "#DD6B55",
			confirmButtonText: "Yes, delete it!",
			cancelButtonText: "No, cancel!",
			closeOnConfirm: true,
			closeOnCancel: true
		}, function(isConfirm){
			if (isConfirm) {
        resourceService.deleteBulkUoms($scope.selected, function(failures) {
          if ( failures && failures.length > 0 ) {
            $scope.alertService.presentAutoAlert('deleteBulkUoms', {status:202, requestName: 'Delete bulk uoms - failures ' + failures.length + ' of ' + $scope.selected.length});
            $scope.loadUomsList();
          } else {
            $scope.alertService.presentAutoAlert('deleteBulkUoms',{status:200});
            $scope.loadUomsList();
          }
        });
			}
		});
  }

});



// WEBPACK FOOTER //
// ./src/controllers/companySettings/uoms.js